import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import TagColor from "../../Common/TagColor";
import ProfileDialog from "../../Profiles/ProfileDialog";
import TableCellStyled from "../../Common/TableCellStyled";
import LogDetailsDialog from "../../Profiles/LogDetailsDialog";
import LiveCardAction from "../../SiteEntranceExit/LiveEvents/LiveCardAction";
import ProfileSurveyDialog from "../../Profiles/ProfileSurvey/ProfileSurveyDialog";

import { formatDate } from "../../../utils/date";

import { walkInOut } from "../../../constants/reducers";
import { measuredTemperature } from "../../../constants/liveEvents";

import colors from "../../../assets/style/colors";

const HspCurrentStatusTableRow = (props) => {
  const { language, item, index } = props;
  const [openLogDialog, setOpenLogDialog] = React.useState(false);

  return (
    <TableRow
      style={{
        backgroundColor: index % 2 === 0 ? colors.white : colors.tableDarkBg,
      }}
    >
      <TableCellStyled>
        {get(item, ["id"]) ? (
          <LogDetailsDialog
            logId={get(item, ["id"])}
            dbPermissions={get(props, ["permissions"])}
            blockLevel2={false}
            refresh={props.refresh}
            open={openLogDialog}
            addTempDirectly={openLogDialog}
            onClose={() => setOpenLogDialog(false)}
          />
        ) : (
          <span className="text-54">-</span>
        )}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {formatDate(get(item, ["main", "dateTime"]))}
      </TableCellStyled>
      <TableCellStyled>
        <ProfileDialog
          profileId={get(item, ["human", "profile", "id"])}
          name={get(item, ["human", "name"])}
          blockLevel2={true}
        />
      </TableCellStyled>
      <TableCellStyled>
        <TagColor
          name={get(item, ["human", "tag"])}
          color={get(item, ["human", "tagColor"])}
        />
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {get(item, ["main", "site"])}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {get(item, ["main", "zone"])}
      </TableCellStyled>
      <TableCellStyled>
        <Grid container alignItems="center" wrap="nowrap">
          <Grid item>
            <ProfileSurveyDialog
              title={get(item, [
                "human",
                "verification",
                0,
                "survey",
                "type",
                `name_${language}`,
              ])}
              onlyOneSurvey
              surveys={
                get(item, ["human", "verification", 0, "reference"])
                  ? {
                      referenceSurvey: get(item, [
                        "human",
                        "verification",
                        0,
                        "survey",
                      ]),
                    }
                  : {
                      lastSurvey: get(item, [
                        "human",
                        "verification",
                        0,
                        "survey",
                      ]),
                    }
              }
              profileId={get(item, ["human", "profile", "id"])}
              profileName={get(item, ["human", "profile", "name"])}
              language={language}
              hide={{ new: true }}
            />
          </Grid>
        </Grid>
      </TableCellStyled>
      <TableCellStyled>
        {get(item, ["human", "verification", 0, "instruction"]) && (
          <Grid container wrap="nowrap" alignItems="center">
            <Grid
              item
              style={{
                marginRight: "5px",
                width: "14px",
                height: "14px",
                backgroundColor: get(item, [
                  "human",
                  "verification",
                  0,
                  "instructionColor",
                ]),
                borderRadius: "2px",
              }}
            />
            <Grid item className="text-54">
              {get(item, ["human", "verification", 0, "instruction"])}
            </Grid>
          </Grid>
        )}
      </TableCellStyled>
      <TableCellStyled className="text-center">
        <LiveCardAction
          section={walkInOut}
          action={measuredTemperature}
          actionProps={{
            data: get(item, ["measuredTemperature"]),
            startTime:
              new Date(get(item, ["detections", "human", "start"])).getTime() ||
              0,
            noTemperatureAction: () => setOpenLogDialog(true),
          }}
        />
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {get(item, ["main", "entryStatus"])}
      </TableCellStyled>
    </TableRow>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default connect(mapStateToProps)(HspCurrentStatusTableRow);
